import { set } from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SachLoader from "../../../commons/Loader";
import { showPopup } from "../../../redux/action/common";
import SuccessImage from "../../../static/admin/img/icons/success.svg";
import calendarIcon from "../../../static/user/img/icons/calendar-o.svg";
import clockIcon from "../../../static/user/img/icons/clock-o.svg";
import listIcon from "../../../static/user/img/icons/digital.svg";

import { fetchEventDetailsCall, registerEventCall, resetEventData, toggleRegisterPopUp } from "../../../redux/action/user/events";
import { checkAuthentication, countdownTimeStart, getCurrentUserDetails, parseHtml } from "../../../utils/util";
import AdminModal from "../common/AdminModal";
import "./style.css";
import { checkPaymentStatus, createPaymentOrder } from "../../../redux/action/user/contribute";
import { SANDBOX_URL } from "../../../redux/constants";

const EventDetails = (props) => {
  const { fetchEventDetailsCall, eventsData, registerEventCall, showPopup, toggleRegisterPopUp, createPaymentOrder, createPaymentData, paymentStatus, checkPaymentStatus } = props;
  let navigate = useNavigate();
  const checkUser = checkAuthentication();

  const authUser = checkUser ? getCurrentUserDetails() : {};
  let eventInfo = eventsData?.eventInfo;
  const location = useLocation();
  const [cl, setCl] = useState("1");
  const [isBuyingTicket, setIsBuyingTicket] = useState(false);

  const eventDetailSection = eventInfo && eventInfo.eventDetails;
  const [contributeSubmitted, setcontributeSubmitted] = useState(false);
  const [queryParameters] = useSearchParams();

  useEffect(() => {
    const orderId = queryParameters.get("order_id");
    if (orderId) {
      checkPaymentStatus({ orderId, contributeOrEvent: "EVENT" });
      setIsBuyingTicket(true);
      setcontributeSubmitted(true);
    } else {
      setcontributeSubmitted(false);
      initializeRazorpay();
    }
  }, []);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramsObj = Object.fromEntries(params);
    fetchEventDetailsCall(paramsObj);
    return () => resetEventData();
  }, []);

  // useEffect(() => {
  //   const orderId = queryParameters.get("order_id");
  //   let timeout;
  //   if (orderId && paymentStatus?.paymentStatus === "ACTIVE") {
  //     // timeout = setTimeout(() => {
  //       checkPaymentStatus({ orderId, contributeOrEvent: 'EVENT' });
  //       setcontributeSubmitted(true);
  //     // }, 1000);
  //   }
  //   if (timeout) {
  //     // clearTimeout(timeout)
  //   }
  // }, [paymentStatus]);
  useEffect(() => {
    if (createPaymentData?.paymentSessionId) {
      startPaymentProcess(createPaymentData);
    }
  }, [createPaymentData]);

  const initializeRazorpay = async () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = SANDBOX_URL;
      script.eval = true;

      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };
  const startPaymentProcess = async (data) => {
    const cf = new Cashfree(data?.paymentSessionId);
    cf.redirect();
  };

  useEffect(() => {
    let timerId = 0;
    if (eventsData?.eventInfo?.dateInterval) {
      timerId = countdownTimeStart(`${eventsData?.eventInfo?.dateInterval}`);
    }
    return () => clearInterval(timerId);
  }, eventsData?.eventInfo?.dateInterval);

  const handleRegisterClick = () => {
    const data = {
      eventId: eventInfo?.eventId,
      userId: eventInfo?.userId,
      type: "register",
      value: !eventInfo?.registerType,
    };
    registerEventCall(data, navigate);
  };

  const paymentGatewayRequest = (data) => {
    if (!checkUser) {
      navigate("/login");
    }
    const requestPayload = {
      eventId: eventInfo?.eventId,
      type: "EVENT",
      contributeOrEvent: "EVENT",
      returnUrl: `${window.location.href}&order_id={order_id}`,
    };
    createPaymentOrder(requestPayload);
  };
  const handleWatchClick = () => {
    const data = {
      eventId: eventInfo?.eventId,
      userId: eventInfo?.userId,
      type: "watch",
      value: !eventInfo?.watchType,
    };
    registerEventCall(data, navigate);
  };

  const onClickShareEvent = () => {
    showPopup("shareEvent", { shareLink: eventInfo?.shareLink, eventDetailSection: eventDetailSection });
  };
  if (eventsData?.isLoading) {
    return <SachLoader />;
  }
  const customStyle = {
    background: eventInfo?.bgColor,
  };
  return (
    <>
      <section className={"event-inner-hero bg_" + cl}>
        <div className="container">
          <div className="row pt-5">
            <div className="col-md-12">
              <nav className="sach-breadcrumb" aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/user/events">{eventDetailSection && eventDetailSection.linkTitle}</Link>
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    {(eventDetailSection && eventDetailSection.happeningNow) || "Happening Now"}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-8">
              <div className="inner-hero-content">
                <h5>
                  {parseHtml(eventInfo?.date)}, {parseHtml(eventInfo?.startTime)}- {parseHtml(eventInfo?.endTime)} {parseHtml(eventInfo?.timeZone)}
                </h5>
                <h1>{parseHtml(eventInfo?.title)}</h1>
                <ul className="sach-inline-pills">
                  {eventInfo?.tags?.length > 0 &&
                    eventInfo?.tags.map((eachTag) => {
                      return (
                        <li>
                          <a href="#" className="custom-sach-pills">
                            {parseHtml(eachTag)}
                          </a>
                        </li>
                      );
                    })}
                </ul>
                <div className="duration-title">{eventDetailSection && eventDetailSection.startIn}</div>
                <div className="duration-container">
                  <div className="duration">
                    <h4 id="event-days"></h4>
                    <h6>{eventDetailSection && eventDetailSection.day}</h6>
                  </div>
                  <div className="duration">
                    <h4 id="event-hours"></h4>
                    <h6>{eventDetailSection && eventDetailSection.hrs}</h6>
                  </div>
                  <div className="duration">
                    <h4 id="event-mins"></h4>
                    <h6>{eventDetailSection && eventDetailSection.min}</h6>
                  </div>
                  <div className="duration">
                    <h4 id="event-secs"></h4>
                    <h6>{eventDetailSection && eventDetailSection.sec}</h6>
                  </div>
                </div>
                {(!eventInfo?.isTicketBuyed || eventInfo?.paymentDetails?.paymentDetailId?.paymentStatus === "SUCCESS") && !eventInfo?.freeTag && !eventInfo?.registerType && (
                  <span className="btn btn-sach me-md-2 me-1 register-btn" onClick={() => (checkUser ? setIsBuyingTicket(true) : navigate("/login"))}>
                    {eventDetailSection?.buyTicketCta || "Buy Ticket"}: ₹{eventInfo?.eventCost}
                  </span>
                )}

                {eventInfo?.freeTag && (
                  <span className="btn btn-sach me-md-2 me-1 register-btn" onClick={handleRegisterClick}>
                    {eventInfo?.registerType ? eventDetailSection && eventDetailSection.decline : eventDetailSection && eventDetailSection.register}
                  </span>
                )}
                <span className="btn btn-sach-2 mx-md-2 mx-1" onClick={onClickShareEvent}>
                  <img src={require("../../../static/user/img/icons/share-orange.svg").default} alt="icon" />
                  {eventDetailSection && eventDetailSection.shareEvent}
                </span>
                <span className="btn btn-sach-2 mx-md-2 mx-1 my-2 my-md-0" onClick={handleWatchClick}>
                  <img src={eventInfo?.watchType ? require("../../../static/user/img/icons/heart-fill-o.svg").default : require("../../../static/user/img/icons/heart-o-orange.svg").default} alt="icon" />
                  {eventDetailSection && eventDetailSection.watchList}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="row">
          <div className="col-md-8">
            <div className="event_inner_typ">
              {eventInfo?.icon && <img src={eventInfo?.icon || require("../../../static/user/img/events/thumbnail.png").default} className="img-fluid mb-4" alt="thumbnail" />}
              {eventInfo?.body?.text?.length > 0 &&
                eventInfo?.body?.text?.map((text) => {
                  return <p>{parseHtml(text)}</p>;
                })}
              {/* <p>Social media capitalizes on isolation by "separating" us from friends, then making us want to check on what these friends are doing. Connecting on social media creates more disconnection. Being on social media actually isolates us from our real-life networks.When people look online and see they're excluded from an activity, it can affect thoughts and feelings, and can affect them physically. A 2018 British study tied social media use to decreased, disrupted, and delayed sleep, which is associated with depression, memory loss, and poor academic performance.</p>
              <p>In this event we will discuss and talk about how we can become self-aware and don't mislead our life through social media and take in the positive way.</p> */}
              {eventInfo?.protocols?.text.length > 0 && (
                <div>
                  <div className="h2">{parseHtml(eventInfo?.protocols?.title)}</div>
                  {eventInfo?.protocols?.text.map((txt) => {
                    return <p>{parseHtml(txt)}</p>;
                  })}
                </div>
              )}

              {/* <p>To attend the event, please RSVP via this registration page.</p>
              <p>To gain access to the building, all attendees must sign-in upon arrival, sign an NDA, and provide proof of full vaccination and booster status</p> */}
              <div className="event_speaker">
                <img src={eventInfo?.speakerDetails?.icon || require("../../../static/user/img/Dr.SubhashChandra.png").default} alt="Speaker" />
                <div className="speaker_details">
                  <i> {eventDetailSection && eventDetailSection.speaker}</i>
                  <h2>{eventInfo?.speakerDetails?.name}</h2>
                  <span>{eventInfo?.speakerDetails?.designation}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="event-sidebar">
              <div className="sidebar-container">
                <h2 className="title">{eventDetailSection && eventDetailSection.eventGuid} 🚀</h2>
                <ul className="event-list">
                  <li>
                    <img src={require("../../../static/user/img/icons/attendees.svg").default} alt="Event Icon" />
                    <span>{eventDetailSection && eventDetailSection.attendees}</span>
                    <b>
                      <i>+{eventInfo?.eventGuide?.attendeesCount}</i>
                      {/* <img src={require("../../../static/user/img/user-image-2.png").default} alt="Attendees" />
                      <img src={require("../../../static/user/img/user-image-3.png").default} alt="Attendees" />
                      <img src={require("../../../static/user/img/user-image-2.png").default} alt="Attendees" />
                      <img src={require("../../../static/user/img/user-image-3.png").default} alt="Attendees" /> */}
                    </b>
                  </li>
                  <li>
                    <img src={require("../../../static/user/img/icons/digital.svg").default} alt="Event Icon" />
                    <span>{eventDetailSection && eventDetailSection.digitalEvent}</span>
                    <b>{eventInfo?.eventGuide?.eventMode} ✨</b>
                  </li>
                  <li>
                    <img src={require("../../../static/user/img/icons/calendar-o.svg").default} alt="Event Icon" />
                    <span>{eventDetailSection && eventDetailSection.eventDate}</span>
                    <b>
                      {parseHtml(eventInfo?.date)}, {parseHtml(eventInfo?.startTime)}- {parseHtml(eventInfo?.endTime)} {parseHtml(eventInfo?.timeZone)}
                    </b>
                  </li>
                  <li>
                    <img src={require("../../../static/user/img/icons/language.svg").default} alt="Event Icon" />
                    <span>{eventDetailSection && eventDetailSection.language}</span>
                    {eventInfo?.eventGuide?.language?.map((txt) => {
                      return <b>{txt}</b>;
                    })}
                  </li>
                  {eventInfo?.address && (
                    <li>
                      <img src={require("../../../static/user/img/icons/language.svg").default} alt="Event Icon" />
                      <span>{eventDetailSection && eventDetailSection.address}</span>
                      <b>{eventInfo?.address} ✨</b>
                    </li>
                  )}
                </ul>
                <div className="event_share_icons">
                  <div className="share-ico cursorPointer" onClick={onClickShareEvent}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M18 15.0005C17.183 15.0005 16.443 15.3305 15.901 15.8615L7.966 12.3355C7.979 12.2245 8 12.1145 8 12.0005C8 11.8865 7.979 11.7765 7.966 11.6655L15.901 8.13949C16.443 8.67049 17.183 9.00049 18 9.00049C19.654 9.00049 21 7.65449 21 6.00049C21 4.34649 19.654 3.00049 18 3.00049C16.346 3.00049 15 4.34649 15 6.00049C15 6.11449 15.021 6.22449 15.034 6.33549L7.099 9.86149C6.557 9.33049 5.817 9.00049 5 9.00049C3.346 9.00049 2 10.3465 2 12.0005C2 13.6545 3.346 15.0005 5 15.0005C5.817 15.0005 6.557 14.6705 7.099 14.1395L15.034 17.6655C15.021 17.7765 15 17.8865 15 18.0005C15 19.6545 16.346 21.0005 18 21.0005C19.654 21.0005 21 19.6545 21 18.0005C21 16.3465 19.654 15.0005 18 15.0005Z" />
                    </svg>
                    <span>{eventDetailSection && eventDetailSection.share}</span>
                  </div>
                  <div className="share-ico cursorPointer" onClick={handleWatchClick}>
                    {eventInfo?.watchType ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C11.734 21 11.48 20.895 11.292 20.706L3.52505 12.926C1.48905 10.886 1.48905 7.567 3.52505 5.527C4.50805 4.543 5.82105 4 7.22005 4C8.61905 4 9.93205 4.543 10.915 5.527L12 6.614L13.084 5.528C14.068 4.543 15.381 4 16.78 4C18.179 4 19.492 4.543 20.475 5.527C22.511 7.567 22.511 10.886 20.476 12.926L12.708 20.707C12.52 20.895 12.266 21 12 21Z" fill="#EE6C4D" />
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <g id="Icons-Others=Heart-Outline">
                          <path id="Icon" fill-rule="evenodd" clip-rule="evenodd" d="M7.21968 6C6.35568 6 5.54568 6.334 4.93968 6.941C3.68168 8.201 3.68168 10.252 4.94068 11.514L11.9997 18.585L19.0597 11.514C20.3187 10.252 20.3187 8.201 19.0597 6.941C17.8477 5.726 15.7117 5.728 14.4997 6.941L12.7077 8.736C12.3317 9.113 11.6677 9.113 11.2917 8.736L9.49968 6.94C8.89368 6.334 8.08468 6 7.21968 6ZM11.9997 21C11.7347 21 11.4797 20.895 11.2927 20.706L3.52468 12.926C1.48868 10.886 1.48868 7.567 3.52468 5.527C4.50868 4.543 5.82068 4 7.21968 4C8.61868 4 9.93168 4.543 10.9147 5.527L11.9997 6.614L13.0847 5.528C14.0687 4.543 15.3807 4 16.7807 4C18.1787 4 19.4917 4.543 20.4747 5.527C22.5117 7.567 22.5117 10.886 20.4757 12.926L12.7077 20.707C12.5197 20.895 12.2657 21 11.9997 21Z"></path>
                        </g>
                      </svg>
                    )}
                    <span>{eventDetailSection && eventDetailSection.watchList}</span>
                  </div>
                </div>
                {eventInfo?.freeTag && (
                  <span className="btn btn-sach me-2 register-btn" onClick={handleRegisterClick}>
                    {eventInfo?.registerType ? eventDetailSection && eventDetailSection.discard : eventDetailSection && eventDetailSection.register}
                  </span>
                )}
                {/* <a href="#" className="btn btn-sach btn-sach-linear theme-orange">
                  <img src={require("../../../static/user/img/icons/calendar-o.svg").default} alt="calender" className="me-2" />
                  <span>Add To Calendar</span>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {eventsData?.popUpShow && (
        <AdminModal onCancel={toggleRegisterPopUp} className="modalT2">
          <div className="modal-content p-0">
            <div className="modal-body pt-0">
              <div className="modal-heading text-center">
                <img src={SuccessImage} alt="success" />

                {eventInfo?.registerType && (
                  <>
                    <h1 className="py-2">{eventDetailSection && eventDetailSection.thanksRegis}</h1>
                    <span>{eventDetailSection && eventDetailSection.thanksDesc}</span>
                  </>
                )}
                {!eventInfo?.registerType && (
                  <>
                    <h1 className="py-2">{eventDetailSection && eventDetailSection.removedEvent}</h1>
                    <span>{eventDetailSection && eventDetailSection.removedDesc}</span>
                  </>
                )}
              </div>
              <ul className="modal-icoList">
                <li>
                  <img src={calendarIcon} alt="icon" />
                  <span>
                    {" "}
                    {parseHtml(eventInfo?.dayName)}, {parseHtml(eventInfo?.date)}
                  </span>
                </li>
                <li>
                  <img src={clockIcon} alt="icon" />
                  <span>
                    {" "}
                    {parseHtml(eventInfo?.startTime)} - {parseHtml(eventInfo?.endTime)} {parseHtml(eventInfo?.timeZone)}
                  </span>
                </li>
                <li>
                  <img src={listIcon} alt="icon" />
                  <span>{eventInfo?.eventGuide?.eventMode}</span>
                </li>
              </ul>
              <div className="inline-hr"></div>
              <div className="row mt-4">
                <div className="col-md-6">
                  <a
                    href="#"
                    onClick={() => {
                      toggleRegisterPopUp();
                      navigate("/user/account?tab=my-events");
                    }}
                    className="btn btn-sach bg-sach w-100 justify-content-center mb-3 mb-md-0"
                  >
                    {eventDetailSection && eventDetailSection.checkDetail}
                  </a>
                </div>
                <div className="col-md-6">
                  <a href="#" onClick={toggleRegisterPopUp} className="btn btn-sach btn-sach-linear w-100 justify-content-center">
                    {eventDetailSection && eventDetailSection.discard}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </AdminModal>
      )}
      {isBuyingTicket && (
        <AdminModal className="modalT2" onCancel={() => setIsBuyingTicket(false)}>
          <div className="modal-content p-0">
            <div className="modal-body pt-0">
              {contributeSubmitted ? (
                <>
                  <div className="container py-2">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 text-center">
                          <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M33.2722 37.8549C32.4812 38.6459 31.0804 38.6459 30.2894 37.8549L27.0492 34.6146L24.0664 37.5974L31.7807 45.3117L47.9326 29.16L44.9477 26.1772L33.2722 37.8549Z" fill="#64C880" />
                            <path
                              d="M68.6217 21.5462C68.5126 21.4432 66.2053 19.2946 63.3257 17.7415C62.992 14.4848 61.8899 11.5308 61.8363 11.3908C61.6222 10.8244 61.1751 10.3773 60.6087 10.1631C60.4686 10.1096 57.5147 9.00751 54.258 8.67381C52.7048 5.79202 50.5543 3.48496 50.4533 3.37569C50.0372 2.93287 49.4522 2.6197 48.8465 2.71237C48.6982 2.71645 45.5466 2.82768 42.4094 3.76705C39.8716 1.69904 37.0041 0.250344 36.8681 0.18847C36.3161 -0.0628233 35.6816 -0.0628233 35.1296 0.18847C34.9936 0.250204 32.1263 1.6989 29.5885 3.76705C26.4512 2.82768 23.2996 2.71645 23.1513 2.71237C22.5168 2.62378 21.9607 2.93273 21.5446 3.37569C21.4436 3.48482 19.2931 5.79202 17.7399 8.67381C14.4832 9.00751 11.5293 10.1096 11.3892 10.1631C10.8228 10.3773 10.3757 10.8244 10.1616 11.3908C10.108 11.5308 9.00592 14.4848 8.67223 17.7415C5.79044 19.2946 3.48337 21.4452 3.37411 21.5462C2.93326 21.9623 2.69026 22.5473 2.71079 23.1529C2.71487 23.3013 2.8261 26.4529 3.76546 29.5901C1.69732 32.1279 0.248622 34.9954 0.186888 35.1312C-0.062296 35.6833 -0.062296 36.3178 0.186888 36.8697C0.248622 37.0057 1.69732 39.873 3.76546 42.4108C2.8261 45.5481 2.71487 48.6998 2.71079 48.848C2.69026 49.4537 2.93326 50.0386 3.37411 50.4548C3.48323 50.5557 5.79044 52.7063 8.67223 54.2594C9.00592 57.5161 10.108 60.4701 10.1616 60.6101C10.3757 61.1766 10.8228 61.6236 11.3913 61.8378C11.5314 61.8913 14.4832 62.9934 17.7399 63.3271C19.2931 66.2069 21.4415 68.514 21.5446 68.6231C21.9586 69.0659 22.554 69.3441 23.1513 69.2884C23.2997 69.2843 26.4513 69.1731 29.5865 68.2337C32.1265 70.2998 34.9938 71.7506 35.1298 71.8123C35.4058 71.938 35.7024 71.9998 35.9991 71.9998C36.2958 71.9998 36.5924 71.938 36.8684 71.8123C37.0044 71.7506 39.8717 70.2998 42.4095 68.2337C45.5468 69.1731 48.6985 69.2843 48.8467 69.2884C49.4729 69.3399 50.0373 69.0659 50.4535 68.6231C50.5564 68.514 52.705 66.2068 54.2581 63.3271C57.5148 62.9934 60.4667 61.8913 60.6067 61.8378C61.1753 61.6236 61.6223 61.1766 61.8365 60.6101C61.89 60.4701 62.9921 57.5161 63.3258 54.2594C66.2056 52.7063 68.5127 50.5578 68.6218 50.4548C69.0646 50.0408 69.3078 49.4558 69.2871 48.848C69.283 48.6996 69.1718 45.548 68.2324 42.4108C70.3006 39.873 71.7493 37.0056 71.811 36.8697C72.0602 36.3176 72.0602 35.6831 71.811 35.1312C71.7493 34.9952 70.3006 32.1279 68.2324 29.5901C69.1718 26.4528 69.283 23.3011 69.2871 23.1529C69.3076 22.5453 69.0645 21.9603 68.6217 21.5462ZM52.406 30.6509L33.2716 49.7855C32.8595 50.1976 32.3198 50.4036 31.7803 50.4036C31.2407 50.4036 30.7008 50.1976 30.2889 49.7855L19.5919 39.0885C18.768 38.2646 18.768 36.9296 19.5919 36.1057L25.5574 30.1402C26.3813 29.3163 27.7162 29.3163 28.5402 30.1402L31.7804 33.3804L43.4559 21.7028C44.2798 20.8789 45.6148 20.8789 46.4387 21.7028L52.4063 27.6683C53.2301 28.4922 53.2295 29.8276 52.406 30.6509Z"
                              fill="#64C880"
                            />
                            <circle cx="35.5" cy="35.5" r="19.5" fill="#64C880" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M52.1772 24.8217C52.8281 25.4725 52.8281 26.5278 52.1772 27.1787L32.1772 47.1787C31.5263 47.8295 30.4711 47.8295 29.8202 47.1787L19.8202 37.1787C19.1693 36.5278 19.1693 35.4725 19.8202 34.8217C20.4711 34.1708 21.5263 34.1708 22.1772 34.8217L30.9987 43.6431L49.8202 24.8217C50.4711 24.1708 51.5263 24.1708 52.1772 24.8217Z" fill="white" />
                          </svg>
                        </div>

                        <div className="sach-title text-center">
                          <h2 className="f-700">{paymentStatus?.paymentStatus === "SUCCESS" ? "Thanks for buying ticket" : "Transaction failed please try again"}</h2>
                          <h4 className="f-700">
                            <span className="o">{paymentStatus?.paymentStatus}</span>
                          </h4>

                          <div className="col-lg-12 text-center my-0 py-3">
                            <button
                              className="btn btn-sach bg-sach-dark px-5"
                              onClick={() => {
                                setcontributeSubmitted(false);
                                setIsBuyingTicket(false);
                                navigate("/user/account?tab=my-events");
                              }}
                            >
                              {eventDetailSection && eventDetailSection.checkDetail}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="modal-heading text-center">
                    <img src={SuccessImage} alt="success" />

                    <h1 className="py-2">{eventDetailSection && eventDetailSection.thanksRegis}</h1>
                    <span>{eventDetailSection && eventDetailSection.thanksDesc}</span>
                  </div>
                  <div className="row mt-2 g-4">
                    <div className="col-md-6">
                      <a href="#" onClick={() => paymentGatewayRequest()} className="btn btn-sach bg-sach w-100 justify-content-center">
                        {(eventDetailSection && eventDetailSection.proceedPayment) || " Proceed to payment"}
                      </a>
                    </div>
                    <div className="col-md-6">
                      <a onClick={() => setIsBuyingTicket(false)} className="btn btn-sach btn-sach-linear w-100 justify-content-center">
                        {eventDetailSection && eventDetailSection.discard}
                      </a>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </AdminModal>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { ContributeReducer, CommonReducer, EventReducer } = state;
  return {
    ...state,
    commonData: CommonReducer,
    eventsData: EventReducer,
    createPaymentData: ContributeReducer?.createPaymentData,
    paymentStatus: ContributeReducer?.paymentStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEventDetailsCall: (data) => dispatch(fetchEventDetailsCall(data)),
    registerEventCall: (data, navigate) => dispatch(registerEventCall(data, navigate)),
    resetEventData: () => dispatch(resetEventData(data)),
    showPopup: (type, data) => dispatch(showPopup(type, data)),
    toggleRegisterPopUp: (data) => dispatch(toggleRegisterPopUp(data)),
    createPaymentOrder: (data) => dispatch(createPaymentOrder(data)),
    checkPaymentStatus: (data) => dispatch(checkPaymentStatus(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDetails);
